/* eslint-disable no-shadow */
enum MessageSearchModeEnums {
  TEXT = 'text',
  DATE = 'date',
}
export default MessageSearchModeEnums;
